// Code generated by pkg/router_helper/make_api.go, DO NOT EDIT.

import { fetchApi } from '../fetchApi'

import * as Types from './type'

export const s3Api = {
  postMediaS3Get_upload_pre_url: {
    method: 'post',
    path: '/api-bff/media/s3/get_upload_pre_url',
    fnMeta: {
      parameters: [
        {
          kind: 'body',
        },
      ],
      returnType: {
        kind: '',
      },
    },
    flag: null,
  },
}

export function postMediaS3Get_upload_pre_url(body: Types.GetUploadPreSignedReqDTO, ...args: any): Promise<Types.GetUploadPreSignedRespDTO> {
  return fetchApi(s3Api.postMediaS3Get_upload_pre_url as any, body, ...args) as Promise<Types.GetUploadPreSignedRespDTO>
}
